import LOGO from "@/assets/images/logo.svg";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { Fragment } from "react";
import { Outlet } from "react-router-dom";
export default function AuthenticationLayout() {
  return (
    <Fragment>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        {/* <Grid
                    item
                    xs={false}
                    sm={4}
                    md={7}
                    sx={{
                        // backgroundImage: 'url(https://source.unsplash.com/random)',
                        backgroundImage: `url(${imagePath})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                /> */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          component={Paper}
          elevation={6}
          square
          display={"flex"}
          flexDirection="column"
          alignContent={"center"}
          justifyContent="center"
        >
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <img
              src={LOGO}
              alt="Logo"
              style={{
                // height: "100%",
                height: "213px",
                maxWidth: "425px",
              }}
            /> */}
            <Box
              component="img"
              sx={{
                height: "100%",
                width: 425,
                maxWidth: { xs: "100%", md: 425 },
              }}
              alt="Logo"
              src={LOGO}
            />
            <Outlet />
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
}
